import { defineComponent as h, openBlock as l, createElementBlock as t, mergeProps as v, unref as o, renderSlot as H, createElementVNode as e, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, g = { key: 1 }, A = { key: 2 }, m = { key: 3 }, M = { key: 4 }, Z = { key: 5 }, f = {
  name: "ScalarIconHouse"
}, y = /* @__PURE__ */ h({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: V, weight: n } = u(r);
    return (d, a) => (l(), t("svg", v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(V)), [
      H(d.$slots, "default"),
      o(n) === "bold" ? (l(), t("g", i, a[0] || (a[0] = [
        e("path", { d: "M222.14,105.85l-80-80a20,20,0,0,0-28.28,0l-80,80A19.86,19.86,0,0,0,28,120v96a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V164h24v52a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V120A19.86,19.86,0,0,0,222.14,105.85ZM204,204H164V152a12,12,0,0,0-12-12H104a12,12,0,0,0-12,12v52H52V121.65l76-76,76,76Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (l(), t("g", g, a[1] || (a[1] = [
        e("path", {
          d: "M216,120v96H152V152H104v64H40V120a8,8,0,0,1,2.34-5.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,216,120Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1)
      ]))) : o(n) === "fill" ? (l(), t("g", A, a[2] || (a[2] = [
        e("path", { d: "M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z" }, null, -1)
      ]))) : o(n) === "light" ? (l(), t("g", m, a[3] || (a[3] = [
        e("path", { d: "M217.9,110.1l-80-80a14,14,0,0,0-19.8,0l-80,80A13.92,13.92,0,0,0,34,120v96a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V158h36v58a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V120A13.92,13.92,0,0,0,217.9,110.1ZM210,210H158V152a6,6,0,0,0-6-6H104a6,6,0,0,0-6,6v58H46V120a2,2,0,0,1,.58-1.42l80-80a2,2,0,0,1,2.84,0l80,80A2,2,0,0,1,210,120Z" }, null, -1)
      ]))) : o(n) === "regular" ? (l(), t("g", M, a[4] || (a[4] = [
        e("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1)
      ]))) : o(n) === "thin" ? (l(), t("g", Z, a[5] || (a[5] = [
        e("path", { d: "M216.49,111.51l-80-80a12,12,0,0,0-17,0l-80,80A12,12,0,0,0,36,120v96a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V156h40v60a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V120A12,12,0,0,0,216.49,111.51ZM212,212H156V152a4,4,0,0,0-4-4H104a4,4,0,0,0-4,4v60H44V120a4,4,0,0,1,1.17-2.83l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,212,120Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  y as default
};
